import React from 'react';
import Css from './MobileNav.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const mobileNav = props => {
  return (
    <React.Fragment>
      <div className={Css['mobile-header']}>
        <div
          className={'text-center lakes-medium font-md pt-2 position-relative'}
        >
          {props.prevClick !== undefined && (
            <div className={Css['back-btn']}>
              <button
                className="btn btn-transparent pt-2"
                onClick={props.prevClick}
              >
                <strong>
                  <FontAwesomeIcon icon={['fas', 'chevron-left']} />
                </strong>
              </button>
            </div>
          )}
          {props.title}
          {props.rightButton !== undefined && (
            <div className={Css['right-btn']}>{props.rightButton}</div>
          )}
        </div>
      </div>
      <div className={Css['mobile-nav']} id={'quoting-mobile-nav'}>
        {props.panels.map(item => (
          <div
            key={item.id}
            onClick={() => props.navClick(item.id)}
            className={
              'nav-item d-inline-block text-uppercase pointer py-3 mx-4 lakes-demibold font-sm' +
              (item.id === props.panelActive ? ' active' : '')
            }
          >
            {item.title}
          </div>
        ))}
      </div>
    </React.Fragment>
  );
};

export default mobileNav;



// WEBPACK FOOTER //
// ./src/components/Quoting/MobileNav/MobileNav.jsx